import React, { useEffect, useState } from "react";
import "./CreatePassword.scss";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import axios from "../../../utils/axios";

import { useNavigate } from "react-router";
import BaseDialog from "../../../modelDialogs/BaseDialog";
import LanguagePicker from "../../../LanguagePicker";
import { encrypt } from "../Login/Login";
import { Link } from "react-router-dom";
import { setSession, setUser } from "../auth-helper";
import { itx, noItx } from "../../../translationItx/itx";

export default function CreatePassword(props: {}) {
  const [seePassword, setSeePassword] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    state._navigate = navigate;

    //
    // for google convertion success tracking
    //
    try {
      (window as any).gtag("js", new Date());
      (window as any).gtag("config", "AW-11451305125");
    } catch (ex) {}
  }, []);

  const queryParameters = new URLSearchParams(window.location.search);
  const email = queryParameters.get("email");

  const resetPasswordSchema = Yup.object().shape({
    password: Yup.string().required(state.translate("register.passwordEnter", "Please enter Password!")).min(8),
    confirmpassword: Yup.string()
      .required(state.translate("register.passwordEnter", "Please enter Password!"))
      .oneOf(
        [Yup.ref(noItx("password")), null],
        state.translate("setPassword.passwordMustMatch", "Passwords must match"),
      ),
  });
  const resetPassword = (values: any, { setSubmitting }: any) => {
    if (email) {
      const payload = {
        email: email,
        password: encrypt(values.password),
        oldPassword: encrypt(values.oldPassword),
      };
      axios
        .post(`/api/forget/set-password`, payload)
        .then((result: any) => {
          if (result.data.DATA.token) {
            // redirect to APP Dashboard

            state.dialogManager.openDialog(
              <BaseDialog
                title={state.translate("Success", "Success")}
                onOk={() => {
                  // state.navigate("/login");
                  const credentials = result.data.DATA;
                  // check here if abo is availiable
                  if (credentials.abo && credentials.abo != "no") {
                    setUser(JSON.stringify(credentials));
                    setSession(credentials.token);
                    state.isLoggedIn = true;
                    (window as any).isEstadaLoggedIn = true;
                    const fromProjectLicense = queryParameters.get("project"); // no itx
                    if (fromProjectLicense && fromProjectLicense == "true") {
                      // Sende Message an Parent Window wenn in iframe
                      if (window.parent !== window) {
                        window.parent.postMessage({ type: "PASSWORD_CREATED_SUCCESS" }, "*");
                      } else {
                        state.navigate("/App");
                      }
                    } else {
                      state.navigate("/");
                    }
                  } else {
                    // if no abo availiable navigate to pricing
                    window.location.href = "https://estada.de/pricing";
                  }

                  return true;
                }}
                okCaption={state.translate("ok", "Ok")}
                noAbortButton={true}
              >
                <div style={{ padding: "20px" }}>
                  {state.translate("setPassword.passwordSucessfullySet", "Your have successfully set your password.")}
                </div>
              </BaseDialog>,
            );
          }
        })
        .catch((e) => {
          if (e.STATUS === "FAILURE") {
            let title = state.translate("error", "Error");
            let text = state.translate("setPassword.error", " Please Try Again.");
            if (e.DATA == "Invalid Password") {
              title = itx("loginPage.invalidPassword", "falsches Passwort");
              text = itx(
                "createPassword.wrongOneTimePasswordText",
                "Leider wurde ein falsches Einmal-Passwort angegeben. Versuche mit dem dem in der Email!",
              );
            }
            state.dialogManager.openDialog(
              <BaseDialog
                title={title}
                onOk={() => {
                  // state.navigate("/login");
                  return true;
                }}
                okCaption={state.translate("ok", "Ok")}
                noAbortButton={true}
              >
                <div style={{ padding: "20px" }}>{text}</div>
              </BaseDialog>,
            );
          }
        })
        .finally(() => setSubmitting(false));
    } else {
      state.dialogManager.openDialog(
        <BaseDialog
          title={state.translate("error", "Error")}
          onOk={() => {
            state.navigate("/login");
            return true;
          }}
          okCaption={state.translate("ok", "Ok")}
          noAbortButton={true}
        >
          <div style={{ padding: "20px" }}>
            {state.translate("setPassword.somthingWentwrong", "Something Went Wrong. Please Try Again.")}
          </div>
        </BaseDialog>,
      );
    }
  };
  const createdOneTimePassword = itx("createPassword.createdOneTimePassword").split("/n");
  const allreadyPassyworAvailiable = itx("createPassword.allreadyPassyworAvailiable").split("/n");
  return (
    <div className="SetPassword main-form">
      <div className="lView">
        <div className="head">
          <span className="title form-title">{itx("createPassword.createPassword", "Passwort vergeben")}</span>
        </div>
        <div className="seperator invisible">
          <div />
          <div />
        </div>
        <div className="text">
          <span className="title form-text">
            {createdOneTimePassword[0]}
            <br />
            {createdOneTimePassword[1]}
          </span>
        </div>

        <Formik
          initialValues={{ email: "", password: "" }}
          onSubmit={resetPassword}
          validationSchema={resetPasswordSchema}
        >
          {({ isSubmitting }) => {
            return (
              <Form>
                <div className="inp" style={{ fontFamily: '"Montserrat", sans-serif' }}>
                  <label className="field-container">
                    <span className="form-label"></span>
                    <span className="form-span input-container" style={{ position: "relative" }}>
                      <i className="la la-lock la-lg input-icon" />
                      <Field
                        className="form-input input-field form-input-override"
                        style={{
                          fontSize: "16px !important",
                          height: "39px",
                          color: "black !important",
                          borderRadius: "3px",
                          background: "#f0f0f0 !important",
                        }}
                        type={seePassword != "old" ? "password" : "text"} // no itx
                        name="oldPassword" // no itx
                        placeholder=""
                      />
                      <label className="input-label">
                        {state.translate("loginPage.oldPassword", "Einmal-Passwort")}
                      </label>
                      <i
                        className="las la-eye"
                        style={{
                          color: "black",
                          position: "absolute",
                          right: "10px",
                        }}
                        onMouseDown={() => setSeePassword("old")} // no itx
                        onMouseUp={() => setSeePassword("")}
                      />
                    </span>
                    <ErrorMessage className="form-error" name="password" component="div" />
                  </label>
                  <label className="field-container">
                    <span className="form-label"></span>
                    <span className="form-span input-container" style={{ position: "relative" }}>
                      <i className="la la-lock la-lg input-icon" />
                      <Field
                        className="form-input input-field form-input-override"
                        style={{
                          fontSize: "16px !important",
                          height: "39px",
                          color: "black !important",
                          borderRadius: "3px",
                          background: "#f0f0f0 !important",
                        }}
                        type={seePassword != "new" ? "password" : "text"} // no itx
                        name="password" // no itx
                        placeholder=""
                      />
                      <label className="input-label">
                        {state.translate("loginPage.newPassword", "Neues Passwort")}
                      </label>
                      <i
                        className="las la-eye"
                        style={{
                          color: "black",
                          position: "absolute",
                          right: "10px",
                        }}
                        onMouseDown={() => setSeePassword("new")} // no itx
                        onMouseUp={() => setSeePassword("")}
                      />
                    </span>
                    <ErrorMessage className="form-error" name="password" component="div" />
                  </label>
                  <label className="field-container">
                    <span className="form-label"></span>
                    <span className="form-span input-container">
                      <i className="la la-lock la-lg input-icon" />
                      <Field
                        className="form-input input-field form-input-override"
                        type={seePassword != "check" ? "password" : "text"} // no itx
                        name="confirmpassword" // no itx
                        placeholder=""
                      />
                      <label className="input-label">
                        {state.translate("setPassword.confirmNewPassword", "Neues Passwort bestätigen")}
                        {/* <RequiredLabel /> */}
                      </label>
                      <i
                        className="las la-eye"
                        style={{
                          color: "black",
                          position: "absolute",
                          right: "10px",
                        }}
                        onMouseDown={() => setSeePassword("check")} // no itx
                        onMouseUp={() => setSeePassword("")}
                      />
                    </span>
                    <ErrorMessage className="form-error" name="confirmpassword" component="div" />
                  </label>
                </div>
                <div className="endItems">
                  <button
                    disabled={isSubmitting}
                    className="submit confirm-button confirm-button-override"
                    type="submit" // no itx
                  >
                    <span>{state.translate("forgotPassword.setPassword", "Passwort setzen")}</span>
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
        <span className="title form-text">
          {allreadyPassyworAvailiable[0]}
          <br />
          {allreadyPassyworAvailiable[1]}
          <Link to={"/login"} className="form-link">
            {state.translate("loginPage.signIn", "Sign in!")}
          </Link>
        </span>
      </div>
      <div className="rView">
        <img
          src="/images/auth/rView.png" // no itx
          alt=""
        />
      </div>
      <LanguagePicker className="language-picker" />
    </div>
  );
}
